import { render } from "./attentive-widget-settings.vue?vue&type=template&id=151765bd&scoped=true"
import script from "./attentive-widget-settings.vue?vue&type=script&lang=js"
export * from "./attentive-widget-settings.vue?vue&type=script&lang=js"

import "./attentive-widget-settings.vue?vue&type=style&index=0&id=151765bd&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151765bd"]])

export default __exports__